import '@babel/polyfill';
import "@fancyapps/fancybox";
// sass
import style from "./css/main.scss";

import Timeline from './js/widgets/timeline/timeline.js';

var imagesLoaded = require('imagesloaded');

function inits() {

    imagesLoaded.makeJQueryPlugin( $ );

    let timeline_el = document.querySelectorAll('#Timeline');
    if(timeline_el.length > 0) window.timeline = new Timeline({});

    document.dispatchEvent(new CustomEvent("timeline_loaded", {detail: {}}));

    window.addEventListener('resize', resize, false);
    resize();

}

function resize(){

}

document.addEventListener("DOMContentLoaded",function(){

    if(window.hasOwnProperty('cordova')){
        document.addEventListener("deviceready", inits, false);
    } else {
        inits();
    }

});

